export default __webpack_public_path__ + "static/media/bgbox1.6123d674.jpg";